import React, { useState } from "react";

function LiquidityLoader({ text }) {

    return (
        <>
            <div className="">
                <div
                    className="position-fixed w-100 mainLoader"
                    style={{
                        zIndex: 1100000000000,
                        // marginTop: -200,
                        height: '100%',
                        marginLeft: 0,
                        background: "var(--loader-bg)",
                        backdropFilter: "blur(20px)",
                        top: '0px',
                        left: '0px'
                    }}
                >
                    <div className="h-100 d-flex align-items-center justify-content-center">
                        <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ flexDirection: 'column' }}>
                            <svg className="mt-n4" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                <circle cx="25" cy="25" r="25" fill="#212121" />
                                <path d="M24.8305 5C25.824 20.1977 42.9365 18.2227 42.9365 25.0027C42.9365 30.5302 34.8078 33.4927 24.7763 33.4927C14.7449 33.4927 6.61613 30.5302 6.61613 25.0027C6.61011 18.2227 23.7226 20.1977 24.7221 5C13.1312 5.03011 3.75 14.0018 3.75 25.075C3.75 36.1481 13.1613 45.1499 24.7763 45.1499C36.3914 45.1499 45.8026 36.1601 45.8026 25.075C45.8026 13.9898 36.4155 5.03011 24.8305 5Z" fill="#E6FF00" />
                            </svg>
                            <p
                                className="text-center loader-text"
                            >
                          {text.heading}

                            </p>
                            {text.paragraph && <p className="text-center loader-text-para">{text.paragraph}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default LiquidityLoader;